module.exports = __webpack_public_path__ + "img/tablet-restaurante.fcf54037.webp";